/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { transparent } = colors;

const select = {
  styleOverrides: {
    select: {
      display: "block",
      alignItems: "center",
      padding: `${pxToRem(13)} ${pxToRem(36)} ${pxToRem(13)} ${pxToRem(14)} !important`,
      minHeight: `${pxToRem(20)} !important`,
      lineHeight: pxToRem(20),
      boxSizing: "content-box",

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: "none",
      height: "auto",
      minHeight: pxToRem(20),
      overflow: "unset",
    },

    icon: {
      display: "block",
      right: pxToRem(12),
      pointerEvents: "none",
    },
  },
};

export default select;
